<template>
  <el-main>
    <el-image :src="banner_image" fit="cover"></el-image>
    <div class="w-info">
      <div class="title">
        <i
          v-if="companyRes.islisting && companyRes.islisting != 0"
          :class="{ ['blue']: companyRes.islisting == 2 ? true : false }"
          >{{ companyRes.islisting == 1 ? "C" : "T" }}</i
        >
        <h3 v-html="companyRes.company_name"></h3>
      </div>
      <div class="info_list">
        <div 
          class="info_list_item" 
          v-for="item in companyInfoList" 
          :key="item.infoName" 
          v-if="item[item.contentType]"
        >
          <el-row v-if="item[item.contentType]">
            <el-col :span="isPc?5:10">
              <em :style="'background-image:url(' + item.icon + ');'"></em>
              <label>{{ item.infoName }}：</label>
            </el-col>
            <el-col :span="isPc?19:14" v-if="item.contentType!=='tshBusinessCompany'">
              <div class="tag-con" v-if="item.contentType === 'isExist'">
                <span class="more" v-if="companyRes.member_name.deputies.length<1">
                  {{ companyRes.member_name.deputy }}
                </span>
                <span
                  class="more little_hand"
                  style="margin-right: 10px;"
                  v-for="it in companyRes.member_name.deputies"
                  :key="it.member_id"
                  v-else
                  @click="fnToMemberDetails(it.member_id, it.associationIDs[0])"
                >
                  <b :style="'background-image:url(' +(it.member_photo ? imgUrl + it.member_photo : 'https://www.sztmas.cn/sztx/assets/images/deputy.png') + ');'"></b>
                  {{ it.member_name }}
                </span>
              </div>
              <div class="tag-con" v-else>
                <span class="more">
                  {{ item[item.contentType] }}
                  <!-- <i v-if="item.contentType === 'address'">查看地圖</i> -->
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="base_info" v-if="companyRes.tshBusinessCompanyJson.length>0">
          <div class="more_btn little_hand" @click="changeShowMore">{{isShowMore?'收起':'展開'}}</div>
          <div class="info_item" v-for="item in companyRes.tshBusinessCompanyJson.slice(0,4)" :key="item">
            <span v-html="item.title"></span>：
            <span v-html="item.contenxt"></span>
          </div>
          <div v-if="isShowMore">
            <div class="other_item" v-for="item in companyRes.tshBusinessCompanyJson.slice(4)" :key="item">
              <span v-html="item.title"></span>：
              <span v-html="item.contenxt"></span>
            </div>
            <div class="other_item" v-if="employees.length>0">
              <span>主要人員：</span>
              <table  border="1" cellspacing="0">
                <tr>
                  <td>姓名</td>
                  <td>職位</td>
                </tr>
                <tr v-for="item in employees" :key="item">
                  <td>{{item.name}}</td>
                  <td>{{item.job_title}}</td>
                </tr>
                
              </table>
            </div>
            <div class="other_item" v-if="partners.length>0">
              <span>股權信息：</span>
              <table v-for="item in partners" :key="item" border="1" cellspacing="0">
                <tr>
                  <td>股東姓名</td>
                  <td>{{item.name}}</td>
                </tr>
                <tr>
                  <td>股東類型</td>
                  <td>{{item.stock_type}}</td>
                </tr>
                <tr>
                  <td>證件類型</td>
                  <td>{{item.identify_type}}</td>
                </tr>
                <tr>
                  <td>證件號碼</td>
                  <td>{{item.identify_no}}</td>
                </tr>
                <tr v-if="item.should_capi_items.length>0">
                  <td>認繳出資額</td>
                  <td>{{item.should_capi_items[0].shoud_capi}}</td>
                </tr>
                <tr v-if="item.should_capi_items.length>0">
                  <td>出資方式</td>
                  <td>{{item.should_capi_items[0].invest_type}}</td>
                </tr> 
                <tr v-if="item.should_capi_items.length>0">
                  <td>出資時間</td>
                  <td>{{item.should_capi_items[0].should_capi_date}}</td>
                </tr>
                <tr v-if="item.real_capi_items.length>0">
                  <td>實繳出資額</td>
                  <td>{{item.real_capi_items[0].real_capi}}</td>
                </tr>
                <tr v-if="item.real_capi_items.length>0">
                  <td>出資方式</td>
                  <td>{{item.real_capi_items[0].invest_type }}</td>
                </tr>
                <tr v-if="item.real_capi_items.length>0">
                  <td>實繳時間</td>
                  <td>{{item.real_capi_items[0].real_capi_date}}</td>
                </tr>
              </table>
            </div>
            <div class="other_item" v-if="changerecords.length>0">
              <span>變更記錄：</span>
              <table v-for="item in changerecords" :key="item" border="1" cellspacing="0">
                <tr>
                  <td>變更項目</td>
                  <td>{{item.change_item}}</td>
                </tr>
                <tr>
                  <td>變更日期</td>
                  <td>{{item.change_date}}</td>
                </tr>
                <tr>
                  <td>變更前內容</td>
                  <td>{{item.before_content}}</td>
                </tr>
                <tr>
                  <td>變更後內容</td>
                  <td>{{item.after_content}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- <el-tab-pane label="公司介绍" name="introduce" v-if="companyRes.company_content"><div v-html="companyRes.company_content"></div></el-tab-pane> -->
        <el-tab-pane label="主要產品" name="product" v-if="productList&&productList.length>0">
          <el-row :gutter="20">
            <el-col :span="isPc?8:12" v-for="item in productList" :key="item.id">
              <div class="grid-content" @click="fnToProductDetails(item.id)">
                <el-image
                  :src="item.product_image"
                  fit="cover"
                ></el-image>
                <span>{{item.name}}</span>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
    
  </el-main>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      companyRes: {},
      banner_image: "",
      companyInfo: [
        {
          infoName: "行業分類",
          icon: "https://www.sztmas.cn/sztx/assets/images/enterprises-menu04.png",
          contentType: "industry_name",
        },
        {
          infoName: "主營產品",
          icon: "https://www.sztmas.cn/sztx/assets/images/enterprises-menu10.png",
          contentType: "main_businee",
        },
        {
          infoName: "所屬地區",
          icon: "https://www.sztmas.cn/sztx/assets/images/enterprises-menu05.png",
          contentType: "area_name",
        },
        {
          infoName: "成立日期",
          icon: "https://www.sztmas.cn/sztx/assets/images/my08.png",
          contentType: "setup_date",
        },
        {
          infoName: "上市日期",
          icon: "https://www.sztmas.cn/sztx/assets/images/enterprise13.png",
          contentType: "listing_data",
        },
        {
          infoName: "發行價",
          icon: "https://www.sztmas.cn/sztx/assets/images/enterprise11.png",
          contentType: "issue_price",
        },
        {
          infoName: "總股本",
          icon: "https://www.sztmas.cn/sztx/assets/images/enterprises12.png",
          contentType: "total_share_capital",
        },
        {
          infoName: "公司地址",
          icon: "",
          icon: "https://www.sztmas.cn/sztx/assets/images/enterprises-menu05.png",
          contentType: "address",
        },
        {
          infoName: "代表人",
          icon: "https://www.sztmas.cn/sztx/assets/images/enterprises-menu06.png",
          contentType: "isExist",
        },
        {
          infoName: "公司職務",
          icon: "https://www.sztmas.cn/sztx/assets/images/enterprises-menu07.png",
          contentType: "position",
        },
        {
          infoName: "聯繫電話",
          icon: "https://www.sztmas.cn/sztx/assets/images/enterprises-menu08.png",
          contentType: "phone",
        },
        {
          infoName: "聯繫郵件",
          icon: "https://www.sztmas.cn/sztx/assets/images/enterprises-menu09.png",
          contentType: "email",
        },
        {
          infoName: "工商信息",
          icon: "https://www.sztmas.cn/sztx/assets/images/enterprises-menu11.png",
          contentType: "tshBusinessCompany",
        },
      ],
      isShowMore:false,
      activeName: 'product',
      productList:[]
    };
  },
  watch:{
    companyInfoList(val){
      console.log(val)
    }
  },
  computed: {
    ...mapState(["infoRes",'isPc']),
    companyInfoList: function() {
      let vm = this;
      let keys = Object.keys(this.companyRes);
      return this.companyInfo.map((item) => {
        keys.map((key) => {
          if (key === item.contentType) {
            item[key] = vm.companyRes[key];
          }
        });
        return item;
      });
    },
    partners(){
      return this.companyRes.tshBusinessCompany.partners?eval(this.companyRes.tshBusinessCompany.partners):[]
    },
    employees(){
      return this.companyRes.tshBusinessCompany.employees?eval(this.companyRes.tshBusinessCompany.employees):[]
    },
    changerecords(){
      return this.companyRes.tshBusinessCompany.changerecords?eval(this.companyRes.tshBusinessCompany.changerecords):[]
    }
  },
  methods: {
    async getCompanyDetail() {
      const { data: res } = await this.$http.get(
        `/api/v2/company/${this.$route.params.id}`
      );
      console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.companyRes = res.data;
      this.banner_image = this.companyRes.slideshow_img ? this.$imgUrl + this.companyRes.slideshow_img : "";
      //代表人是否已關聯
      this.companyRes.isExist = this.companyRes.deputies||this.companyRes.deputy?true:false;
      this.companyRes.member_photo = this.companyRes.member_photo?(this.$imgUrl + this.companyRes.member_photo):'https://www.sztmas.cn/sztx/assets/images/deputy.png'
      this.companyRes.member_name = {deputies:this.companyRes.deputies,deputy:this.companyRes.deputy}
      console.log(typeof eval(this.companyRes.tshBusinessCompanyJson));
      this.companyRes.tshBusinessCompanyJson=this.companyRes.tshBusinessCompanyJson?eval(this.companyRes.tshBusinessCompanyJson):[]
      setTimeout(()=>{
        this.$zhTran()
      },300)
    },
    async getProductList(company_id) {
      const { data: res } = await this.$http.get(
        `/api/v2/product/list`, {
        params: {
          start: 0,
          limit: 100,
          searchJson: {
            company_id: this.$route.params.id,
          },
        },
      });
      console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.productList = res.data.map(item => {
        return {
          product_image: this.$imgUrl + item.product_image,
          main_image: item.product_image,
          name: item.product_name,
          id: item.product_id
        }
      });
    },
    fnToMemberDetails(member_id){
      this.$router.push({
        path: `/member_details/${member_id}`,
      })
    },
    fnToProductDetails(product_id){
      this.$router.push({
        path: `/product_details/${product_id}`,
      })
    },
    changeShowMore(){
      this.isShowMore=!this.isShowMore
    },
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  created() {
    this.getCompanyDetail();
    this.getProductList()
  },
};
</script>

<style lang="less" scoped>
.el-main {
  width: 700px;
  margin-top: 40px;
  .el-image {
    width: 100%;
    height: 350px;
  }
  .title {
    display: flex;
    align-items: center;
    width: 100%;
    h3 {
      font-size: 24px;
      color: #010101;
      font-weight: bold;
      line-height: 72px;
      // padding: 20px 0 32px;
    }
    i {
      background: #f12e2b;
      color: #ffffff;
      position: relative;
      left: -10px;
      font-size: 40px;
      border-radius: 26px;
      width: 52px;
      height: 52px;
      line-height: 52px;
      text-align: center;
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
      -webkit-transform-origin: 50% 30%;
      transform-origin: 50% 30%;
    }
    i.blue {
      background: #67a2ea;
    }
  }
  /deep/.info_list_item {
      padding: 10px 0;

    .e-row{
      padding: 15px 0 0;
    }
    .tag-name {
      display: -webkit-flex; /* Safari */
      display: flex;
      align-items: center;
      /* justify-content: center; */
    }
    em {
      width: 24px;
      height: 24px;
      display: inline-block;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      margin-right: 12px; 
      vertical-align: middle;
    }
    label {
      font-size: 18px;
      color: #666;
      line-height: 20px;
      font-weight: normal;
    }
    span {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      line-height: 22px;
      /* margin-left: 8px; */
    }
    /* .tag-con{
      padding: 10px 0;
    } */
    b {
      width: 40px;
      height: 40px;
      border-radius: 40px;
      display: inline-block;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      /* margin-right: 16px; */
      vertical-align: middle;
    }
    i {
      font-size: 14px;
      color: #f12e2b;
      line-height: 13px;
      padding: 2px 5px;
      background: #ffe9e9;
      border-radius: 5px;
      white-space: nowrap;
      margin-left: 8px;
      font-weight: normal;
    }
  }
  .base_info{
    padding: 0 30px 10px;
    font-size: 16px;
    line-height: 24px;
    background: #ffffff;
    position: relative;
    z-index: 99;
    div span:first-child{
      color: #666;
    }
    div span:nth-child(2){
      color: #333;
      font-weight: bold;
    }
    .more_btn{
      // width: 70px;
      font-size: 18px;
      color: #ffffff;
      line-height: 22px;
      padding: 6px 18px;
      background: #ddd;
      border-radius: 27px;
      margin: auto;
      box-sizing: border-box;
      position: absolute;
      right: 30px;
      top: 10px;
    }
    .info_item,.info_code,.other_item{
      padding: 6px 0;
    }
    .other_item table{
      /* border: 2px solid #dddddd; */
      width: 100%;
      text-align: center;
      margin-bottom: 20px;
    }
    .other_item table tr td:first-child{
      width: 190px ;
      /* border-bottom: 2px solid #dddddd; */
    }
  }
  /deep/.el-tabs__header{
    border: 1px solid rgba(0, 0, 0, 0.03);
    margin-top: 25px;
    padding: 0 20px;
    .el-tabs__nav-wrap::after{
      content: none;
    }
    .el-tabs__item {
      font-size: 20px;
      // padding-top: 10px;
      // padding-bottom: 10px;
      height: auto;
      font-weight: normal;
    }
    .el-tabs__item.is-active{
      color: #4f4e95;
    }
    .el-tabs__item:hover {
      color: #4f4e95 !important;
      font-weight: bold;
    }
    .el-tabs__item.is-active {
      color: #4f4e95 !important;
      font-weight: bold;
    }
    .el-tabs__active-bar{
      background-color: #4f4e95;
    }
  }
  .el-tab-pane{
    padding: 0 20px;
    .el-row{
      margin-top: 15px;
    }
    .grid-content{
      text-align: center;
      .el-image{
        height: 160px;
      }
      span{
        font-size:18px;
        font-weight:400;
        color:#424242;
        line-height: 50px;
      }
    }
  }
  
}
@media screen and (max-width: 768px){
  .el-main {
    width: 100%;
    margin: 0;
    .w-info{
      padding: 0 20px;
      .title{
        h3{
          line-height: 40px;
        }
      }
    }
    .base_info .more_btn{
      top: -40px;
    }
  }
}
</style>
